<template>
	<div style="display: flex; flex-direction: column; margin-left: 25px; margin-right: 25px; margin-top: 20px;">
		<div class="miniCard"
			style="background: RGBA(236, 240, 243, 1); border-radius: 16px; display: flex; flex-direction: column;" :style="{boxShadow: !isPdfShow ? '5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF' : '', background: !isPdfShow ? ' RGBA(236, 240, 243, 1)' : '#E0E6EF'}">
			<div class="miniCardTop" @click="unflodClick" style="cursor: pointer;">
				<div style="display: flex; width: 100%; height: 34px;">
					<div style="display: flex; flex: 1;">
						<img style="width: 28px; height: 28px; margin-left: 15px; border-radius: 10px; margin-top: 3px;"
							:src="data && data.icon ? require('../../../assets/' + data.icon + '.png') : ''" alt="">
						<div style="margin-left: 10px; position: relative; margin-top: 3px;">
							<div v-html="$options.filters.reMate(data && data.titleLabel ? data.titleLabel : ' ')"></div>
							<div v-if="type != 1"
								style="position: absolute; bottom: 4px; width: 47px; height: 8px; background: linear-gradient(270deg, rgba(24,144,255,0) 0%, rgba(255,113,134,0) 0%, #FF7186 100%); border-radius: 5px; opacity: 0.3;">
							</div>
							<div v-if="type == 1"
								style="position: absolute; bottom: 4px; width: 47px; height: 8px; background: linear-gradient( 270deg, rgba(74,124,232,0) 0%, #4A7CE8 100%); border-radius: 5px; opacity: 0.3;">
							</div>
						</div>
						<QuestionMarkA v-if="data && data.questionMarkType" />
					</div>
					<div style="width: 34px; height: 34px; display: flex; justify-content: center; align-items: center;">
						<div :class="isUnfold ? 'unfoldImgTrue' : 'unfoldImgFalse'" style="width: 14px; height: 14px;">
						</div>
					</div>
				</div>
				<div
					style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A4ABB6; line-height: 22px; margin-left: 53px; margin-right: 49px; margin-top: 1px;">
					{{ data && data.conclusion ? data.conclusion : ' ' }}</div>
			</div>
			<div v-show="isUnfold"
				style="background: rgba(255,255,255,0.85); margin-left: 5px; margin-right: 5px; margin-bottom: 5px; border-radius: 12px; padding-top: 5px; padding-bottom: 25px;">
				<div v-if="data && data.subTitle" style="display: flex; align-items: center; margin-bottom: 10px; margin-top: 15px;">
					<div style="width: 4px; height: 14px; background: #4A7CE8; border-radius: 2px; margin-left: 15px;">
					</div>
					<div
						style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 22px; margin-left: 10px;">
						{{ '上床、入睡、醒来、起床时间点分布' }}</div>
				</div>

				<div style="display: flex; flex-direction: column; flex: 1;">
					<div style="display: flex; width: 100%; justify-content: space-between;">
						<div
							style="font-size: 10px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: rgba(165, 169, 188, 1); margin-left: 50px;">
							19:30
						</div>
						<div
							style="font-size: 10px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: rgba(165, 169, 188, 1); margin-right: 10px;">
							08:30
						</div>
					</div>
					<div
						style=" height: 2px; background-color: rgba(198, 231, 255, 0.3); margin-top: 2px; margin-left: 50px; margin-right: 10px;">
					</div>
					<div id="lawEchartScrollView" style="height: 267px;overflow: auto;">
						<div :id="echartId" :style="{ width: '100%', height: (data.data.length * 32) + 'px' }" v-if="data && data.data"></div>
					</div>
					<!-- <div
						style=" height: 2px; background-color: rgba(198, 231, 255, 0.3); margin-top: 2px; margin-left: 44px; margin-right: 10px;">
					</div>
					<div style="display: flex; height: 267px; position: relative;">
						<div
							style="width: 1px; background-color: rgba(219, 238, 250, 0.3); position: absolute; height: 100%; left: 44px; top: 0px;">
						</div>
						<div :id="echartId" :style="{ width: '100%', height: '100%' }"></div>
						<div
							style="width: 1px; background-color: rgba(219, 238, 250, 0.3); position: absolute; height: 100%; right: 10px; top: 0px;">
						</div>
						<div
							style="height: 1px; background-color: rgba(219, 238, 250, 0.3); position: absolute;left: 44px; right: 10px; bottom: 0px;">
						</div>
						<div
							style="height: 1px; background-color: rgba(219, 238, 250, 0.3); position: absolute;left: 45px; right: 11px; top: 19px; z-index: -1;">
						</div>
						<div
							style="height: 1px; background-color: rgba(219, 238, 250, 0.3); position: absolute;left: 45px; right: 11px; top: 48px; z-index: -1;">
						</div>
						<div
							style="height: 1px; background-color: rgba(219, 238, 250, 0.3); position: absolute;left: 45px; right: 11px; top: 76px; z-index: -1;">
						</div>
						<div
							style="height: 1px; background-color: rgba(219, 238, 250, 0.3); position: absolute;left: 45px; right: 11px; top: 105px; z-index: -1;">
						</div>
					</div> -->
				</div>

				<div style="display: flex; justify-content: center; margin-top: 10px;">
					<div style="display: flex; align-items: center; margin-right: 12px;">
						<div style="width: 6px;height: 6px; background: #FF7186; border-radius: 3px; margin-right: 4px;"></div>
						<div style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 17px;">{{ '上床' }}</div>
					</div>
					<div style="display: flex; align-items: center; margin-right: 12px;">
						<div style="width: 6px;height: 6px; background: #FFB971; border-radius: 3px; margin-right: 4px;"></div>
						<div style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 17px;">{{ '入睡' }}</div>
					</div>
					<div style="display: flex; align-items: center; margin-right: 12px;">
						<div style="width: 6px;height: 6px; background: #44D7B6; border-radius: 3px; margin-right: 4px;"></div>
						<div style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 17px;">{{ '醒来' }}</div>
					</div>
					<div style="display: flex; align-items: center; margin-right: 12px;">
						<div style="width: 6px;height: 6px; background: #1890FF; border-radius: 3px; margin-right: 4px;"></div>
						<div style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 17px;">{{ '起床' }}</div>
					</div>
				</div>
				
				<div v-if="data" style="background: linear-gradient(225deg, rgba(148,192,249,0.1) 0%, rgba(173,195,243,0.1) 100%); border-radius: 8px; border: 2px rgba(74, 124, 232, 0.1) solid; margin-left: 15px; margin-right: 15px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 21px; padding-left: 10.5px; padding-right: 10.5px; padding-top: 15px; padding-bottom: 15px; margin-top: 10px;">
					<div v-if="go_bed_str || go_sleep_str || get_sleep_str || get_bed_str"
						style="display: flex;">
						<div v-for="(item, indexOut) in ['上床时间高频范围', '入睡时间高频范围', '醒来时间高频范围', '起床时间高频范围']"
							style="display: flex; flex: 1; margin-left: 4.5px; margin-right: 4.5px; background: #FFFFFF; border-radius: 4px; height: 73px;">
							<div v-if="indexOut == 0" style="flex: 1; display: flex; align-items: center; flex-direction: column; justify-content: center;">
								<div style="display: flex; align-items: center;">
									<div style="width: 16px; height: 5px; background: #FF7186; opacity: 0.3;"></div>
									<div
										style="font-size: 12px; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 17px; margin-left: 5px;">
										{{ item }}</div>
								</div>
								<div
									style="font-size: 14px; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #5E6779; line-height: 21px; margin-top: 5px;">
									{{ go_bed_str }}</div>
							</div>
							<div v-if="indexOut == 1" style="flex: 1; display: flex; align-items: center; flex-direction: column; justify-content: center;">
								<div style="display: flex; align-items: center;">
									<div style="width: 16px; height: 5px; background: #FFB971; opacity: 0.3;"></div>
									<div
										style="font-size: 12px; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 17px; margin-left: 5px;">
										{{ item }}</div>
								</div>
								<div
									style="font-size: 14px; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #5E6779; line-height: 21px; margin-top: 5px;">
									{{ go_sleep_str }}</div>
							</div>
							<div v-if="indexOut == 2" style="flex: 1; display: flex; align-items: center; flex-direction: column; justify-content: center;">
								<div style="display: flex; align-items: center;">
									<div style="width: 16px; height: 5px; background: #44D7B6; opacity: 0.3;"></div>
									<div
										style="font-size: 12px; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 17px; margin-left: 5px;">
										{{ item }}</div>
								</div>
								<div
									style="font-size: 14px; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #5E6779; line-height: 21px; margin-top: 5px;">
									{{ get_sleep_str }}</div>
							</div>
							<div v-if="indexOut == 3" style="flex: 1; display: flex; align-items: center; flex-direction: column; justify-content: center;">
								<div style="display: flex; align-items: center;">
									<div style="width: 16px; height: 5px; background: #1890FF; opacity: 0.3;"></div>
									<div
										style="font-size: 12px; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 17px; margin-left: 5px;">
										{{ item }}</div>
								</div>
								<div
									style="font-size: 14px; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #5E6779; line-height: 21px; margin-top: 5px;">
									{{ get_bed_str }}</div>
							</div>
						</div>
					</div>
					<div v-if="data && data.descLabel" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 21px; margin-top: 10px; margin-left: 4.5px; margin-right: 4.5px;">
						{{ data && data.descLabel ? data.descLabel : ' '  }}</div>
				</div>
			</div>

		</div>
	</div>
</template>
  
<script>
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';
import QuestionMarkA from '../component/questionMarkA.vue'
import data from '../../../utils/data';

export default {
	components: {
		QuestionMarkA,
	},
	filters: {
		reMate(val) {
			return CustomRichText.reMateNew(portFn.function_reg_str_to_arr(val))
		},
	},
	props: {
		data: null,
		echartId: {
			type: String,
			default: null,
		},
		option: {
			type: Object,
			default: null
		},
		isPdfShow: {
			type: Boolean,
			default: false
		},
		isFold: {
			type: Boolean,
			default: false
		},
		type: {
			type: Number,
			default: 0 // 0 - 红色，1 - 黄色
		}
	},
	watch: {
		option(newVal, oldVal) {
			if (newVal) {
				let option = newVal;
				this.myChart_Bar = this.$echarts.init(document.getElementById(this.$props.echartId), null, { renderer: 'svg' });
				this.myChart_Bar.setOption(option, true);
				window.addEventListener('resize', () => {
					this.myChart_Bar.resize();
				});
				this.$forceUpdate()
			}
		}
	},
	data() {
		return {
			isUnfold: true,
			go_bed_str: null,
			go_sleep_str: null,
			get_sleep_str: null,
			get_bed_str: null
		};
	},
	created() { },
	mounted() {
		if (this.$props.isFold == true) {
			this.isUnfold = false;
		}
		if (this.$props.option) {
			let option = this.$props.option;
			this.myChart_Bar = this.$echarts.init(document.getElementById(this.$props.echartId), null, { renderer: 'svg' });
			this.myChart_Bar.setOption(option, true);
			window.addEventListener('resize', () => {
				this.myChart_Bar.resize();
			});
			this.$forceUpdate()

			// id为lawEchartScrollView的dom滚动到底部
			let message = document.getElementById('lawEchartScrollView');
			message.scrollTop = message.scrollHeight;
		}

		// 区间范围
		if (this.$props.data && this.$props.data.highFreTime) {
			let go_bed_start = this.$props.data.highFreTime.getBedSt;
			let go_bed_end = this.$props.data.highFreTime.getBedEd;
			let go_sleep_start = this.$props.data.highFreTime.sleepStSt;
			let go_sleep_end = this.$props.data.highFreTime.sleepStEd;
			let get_sleep_start = this.$props.data.highFreTime.sleepEdSt;
			let get_sleep_end = this.$props.data.highFreTime.sleepEdEd;
			let get_bed_start = this.$props.data.highFreTime.leaveBedSt;
			let get_bed_end = this.$props.data.highFreTime.leaveBedEd;
			this.go_bed_str = (go_bed_start && go_bed_end) ? go_bed_start + '～' + go_bed_end : '暂无';
			this.go_sleep_str = (go_sleep_start && go_sleep_end) ? go_sleep_start + '～' + go_sleep_end : '暂无';
			this.get_sleep_str = (get_sleep_start && get_sleep_end) ? get_sleep_start + '～' + get_sleep_end : '暂无';
			this.get_bed_str = (get_bed_start && get_bed_end) ? get_bed_start + '～' + get_bed_end : '暂无';
		}
		
	},
	methods: {
		unflodClick() {
			this.isUnfold = !this.isUnfold;
		},
	},
};
</script>
<style lang="scss" scoped>
.miniCard ::v-deep {
	background: #ECF0F3;

	.unfoldImgTrue {
		background: url('../../../assets/icon_common_special_arrow_10.png') no-repeat no-repeat;
		background-size: contain;
	}

	.unfoldImgFalse {
		background: url('../../../assets/icon_common_special_arrow_9.png') no-repeat no-repeat;
		background-size: contain;
	}

	.richContentStyle {
		display: flex;
	}

	.richTextStyleNormal {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(31, 38, 53, 1);
		line-height: 25px;
	}

	.richTextStyleRed {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(255, 113, 134, 1);
		line-height: 25px;
	}
}

.miniCard:hover {
	background: rgba(223, 232, 252, 1) !important;

	.unfoldImgTrue {
		background: url('../../../assets/icon_common_special_arrow_12.png') no-repeat no-repeat;
		background-size: contain;
	}

	.unfoldImgFalse {
		background: url('../../../assets/icon_common_special_arrow_11.png') no-repeat no-repeat;
		background-size: contain;
	}
}

.miniCardTop {
	background: rgba(255, 255, 255, 0.85);
	border-radius: 12px;
	border: 1px solid #FFFFFF;
	display: flex;
	flex-direction: column;
	padding-top: 12px;
	padding-bottom: 15px;
	margin: 5px;
}

</style>
  